(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["srsly-subscription-selector"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('srsly-subscription-selector')) {
    customElements.define('srsly-subscription-selector', class extends HTMLElement {
      connectedCallback() {
        this.frame = requestAnimationFrame(() => this.start());
      }

      disconnectedCallback() {
        cancelAnimationFrame(this.frame);
        this.observer?.disconnect();
        this.events?.abort();
        if (this.dialog?.open) this.dialog.close();
      }

      start() {
        this.events?.abort();
        this.events = new AbortController();
        const opts = {signal: this.events.signal};
        this.native = this.querySelector('[data-native]');
        this.ui = this.querySelector('[data-ui]');
        this.scope = this.closest('product-info');
        this.dialog = this.querySelector('dialog');
        this.trigger = this.querySelector('[data-frequency]');
        if (!this.native || !this.scope) return;
        try {
          this.groups = JSON.parse(this.querySelector('[data-plans]').textContent).filter(group => String(group.app_id).split('/').pop() === '66228322305');
        } catch { return; }
        this.addEventListener('change', event => {
          if (event.target.matches('[data-once]')) this.choose(this.once);
          else if (event.target.matches('[data-subscribe]')) this.choose(this.choice?.radio);
          else if (this.native.contains(event.target)) this.schedule();
        }, opts);
        this.trigger.addEventListener('click', () => this.openPicker(), opts);
        this.querySelector('[data-close]').addEventListener('click', () => this.dialog.close(), opts);
        this.dialog.addEventListener('click', event => {
          if (event.target !== this.dialog) return;
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
        }, opts);
        this.dialog.addEventListener('close', () => { this.trigger.setAttribute('aria-expanded', 'false'); this.trigger.focus(); }, opts);
        this.scope.addEventListener('change', () => this.schedule(), opts);
        window.addEventListener('resize', () => { if (this.dialog.open) this.positionPicker(); }, opts);
        this.observer?.disconnect();
        this.observer = new MutationObserver(records => {
          if (records.some(record => !this.ui.contains(record.target))) this.schedule();
        });
        this.observer.observe(this.scope, {subtree:true, childList:true, attributes:true, attributeFilter:['value','class','disabled']});
        document.addEventListener('DOMContentLoaded', () => this.schedule(), opts);
        this.refresh();
      }

      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.refresh());
      }

      fallback() {
        if (this.dialog?.open) this.dialog.close();
        this.native.hidden = false;
        this.ui.hidden = true;
      }

      refresh() {
        const form = document.getElementById(this.dataset.formId);
        const variant = form?.querySelector('[name="id"]')?.value;
        const section = Array.from(this.native.querySelectorAll('section[data-variant-id]')).find(node => node.dataset.variantId === variant);
        if (!section || !form.querySelector('[name="selling_plan"]')) { this.fallback(); return; }
        const radios = Array.from(section.querySelectorAll('input[data-radio-type="selling_plan"]'));
        this.plans = this.groups.flatMap(group => group.selling_plans.filter(plan => plan.recurring_deliveries).map(plan => ({...plan, group:group.name, radio:radios.find(radio => radio.dataset.sellingPlanId === String(plan.id))}))).filter(plan => plan.radio);
        if (!this.plans.length) { this.fallback(); return; }
        this.once = section.querySelector('input[data-radio-type="one_time_purchase"]');
        const variantChanged = this.variant !== variant;
        const preferred = this.plans.find(plan => String(plan.id) === this.remembered) || this.plans.find(plan => /\bevery\s+3\s+weeks?\b/i.test(plan.name)) || this.plans.find(plan => !plan.radio.disabled) || this.plans[0];
        if (variantChanged) {
          this.variant = variant;
          this.choice = preferred;
          const next = this.subscribed || !this.once ? preferred.radio : this.once;
          if (!next.disabled) {
            next.checked = true;
            next.dispatchEvent(new Event('change', {bubbles:true}));
          }
          if (this.dialog.open) this.dialog.close();
        }
        const checked = section.querySelector('input[data-radio-type]:checked');
        const selectedPlan = this.plans.find(plan => plan.radio === checked);
        if (checked !== this.once && !selectedPlan) { this.fallback(); return; }
        if (form.querySelector('[name="selling_plan"]').value !== (checked?.dataset.sellingPlanId || '')) { this.fallback(); return; }
        this.choice = selectedPlan || preferred;
        this.subscribed = !!selectedPlan;
        this.querySelector('[data-one-row]').hidden = !this.once;
        this.querySelector('[data-once]').checked = !this.subscribed;
        this.querySelector('[data-once]').disabled = !this.once || this.once.disabled;
        this.querySelector('[data-subscribe]').checked = this.subscribed;
        this.querySelector('[data-subscribe]').disabled = this.choice.radio.disabled;
        this.trigger.disabled = this.plans.every(plan => plan.radio.disabled);
        this.querySelector('[data-once-price]').textContent = this.once?.dataset.variantPrice || '';
        const price = this.choice.radio.dataset.variantPrice;
        const adjustments = this.choice.price_adjustments || [];
        this.querySelector('[data-sub-price]').textContent = (adjustments.length > 1 ? this.dataset.from + ' ' : '') + price;
        const saving = this.querySelector('[data-saving]');
        const adjustment = adjustments[0];
        const percent = adjustment?.value_type === 'percentage' && adjustments.length === 1 ? Number(adjustment.value) : 0;
        saving.hidden = percent <= 0;
        saving.textContent = percent > 0 ? this.dataset.save.replace('[amount]', percent + '%') : '';
        this.querySelector('[data-frequency-text]').textContent = this.dataset.delivery.replace('[frequency]', this.frequency(this.choice).replace(/^Every\b/, 'every'));
        this.native.hidden = true;
        this.ui.hidden = false;
      }

      frequency(plan) {
        const option = plan.options.find(option => /frequency/i.test(option.name)) || plan.options[0];
        return (option?.value || plan.name).replace(/^Deliver\s+/i, '').replace(/^every\b/, 'Every');
      }

      choose(radio) {
        if (!radio || radio.disabled) return;
        radio.checked = true;
        radio.dispatchEvent(new Event('change', {bubbles:true}));
        if (radio.dataset.sellingPlanId) this.remembered = radio.dataset.sellingPlanId;
        this.refresh();
        const form = document.getElementById(this.dataset.formId);
        const expected = radio.dataset.sellingPlanId || '';
        if (form.querySelector('[name="selling_plan"]')?.value !== expected) this.fallback();
      }

      openPicker() {
        this.refresh();
        if (this.ui.hidden) return;
        const options = this.querySelector('[data-options]');
        options.replaceChildren();
        this.plans.forEach(plan => {
          const button = document.createElement('button');
          button.type = 'button';
          button.className = 'srsly-buy__option';
          button.disabled = plan.radio.disabled;
          button.setAttribute('aria-pressed', String(plan.id === this.choice.id));
          const label = document.createElement('span');
          label.textContent = this.frequency(plan);
          const price = document.createElement('span');
          price.textContent = plan.radio.dataset.variantPrice;
          button.append(label, price);
          button.addEventListener('click', () => { this.choose(plan.radio); this.dialog.close(); });
          options.append(button);
        });
        this.dialog.showModal();
        this.trigger.setAttribute('aria-expanded', 'true');
        this.positionPicker();
        options.querySelector('[aria-pressed="true"]')?.focus({preventScroll:true});
      }

      positionPicker() {
        if (window.innerWidth < 750) return;
        const anchor = this.trigger.getBoundingClientRect();
        const rect = this.dialog.getBoundingClientRect();
        const top = anchor.bottom + rect.height + 12 < window.innerHeight ? anchor.bottom + 8 : Math.max(12, anchor.top - rect.height - 8);
        this.dialog.style.top = top + 'px';
        this.dialog.style.left = Math.max(12, Math.min(anchor.left, window.innerWidth - rect.width - 12)) + 'px';
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
